import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";
import { employeesVerificationUpdate } from "../../../core/data/redux/employeesVerificationSlice";
import FaceVerificationTable from "./faceVerificationTable";

interface EmployeesVerificationListProps {}

const FaceVerificationList = (props: EmployeesVerificationListProps) => {
  const routes = all_routes;
  const [type, setType] = useState("PENDING");
  const onChange = (key: string) => {
    setType(key);
  };
  const employeesVerificationState = useSelector(
    (state: any) => state.employeesVerificationState
  );

  const tabs: any[] = ["PENDING", "VERIFIED", "REJECTED"];
  const dispatch = useDispatch();
  const [docurl, setDocurl] = useState<any>(null);
  const [currentItem, setCurrentItem] = useState<any>(null);

  const handleUpdate = async (status: any) => {
    await dispatch(
      employeesVerificationUpdate({ id: currentItem.id, is_verified: status })
    );
    setCurrentItem(null);
    //fetchRecords();
  };
  const setItem = async (item: any) => {
    setCurrentItem(item);
  };

  React.useEffect(() => {
    if (
      employeesVerificationState.loading === "fulfilled" &&
      employeesVerificationState.action === "get"
    ) {
      const result = employeesVerificationState?.data?.data || null;
      setDocurl(result.url);
    }
  }, [employeesVerificationState.loading]);

  return (
    <div>
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Face Data Verifications</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Fece Verifications</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Face Data Verifications
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <FaceVerificationTable type={type} setItem={setItem} />
            {/* <Tabs
              onChange={onChange}
              type="card"
              items={tabs.map((item) => {
                return {
                  label: `${item}`,
                  key: item,
                  children: <FaceVerificationTable type={type} setItem={setItem}/>,
                };
              })}
            /> */}
          </div>
        </div>
      </>

      <div
        className="modal fade"
        id="verify-doc"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="assignOfficeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Verify Document/Photo</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body" style={{ textAlign: "center" }}>
              <img src={docurl} width={400} height={400} />
            </div>

            {currentItem?.is_verified == "PENDING" && (
              <div className="modal-footer">
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={() => handleUpdate("VERIFIED")}
                >
                  Approve
                </Link>{" "}
                &nbsp;&nbsp;
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={() => handleUpdate("REJECTED")}
                >
                  Reject
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaceVerificationList;
